

























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import { AloForgottenPass, getDefaultAloForgottenPass } from '../../models/alo/AloForgottenPass';
import * as rules from '@/utils/validationRules'

@Component({
  name: 'ChangePassword',    
  components:{EditDrawer}
})
export default class ChangePassword extends Vue {
    
  private modified:AloForgottenPass = getDefaultAloForgottenPass() as AloForgottenPass
  private showDrawer = false
  private saving = false
  private newPassVerif = ""
  private passwordMinLength = 8
  
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }
  rulePasswordMinLength(v:string) {
    return rules.rulePasswordMinLength(v)    
  }
  rulePasswordMatch(v:string) {
    return rules.rulePasswordMatch(v,this.modified.userNewPass)        
  }
  
  edit() {
    this.showDrawer = true   
    this.newPassVerif = "" 
    this.modified = {...getDefaultAloForgottenPass(),userEmail:this.$store.myGetters.user.usrEmail}
  }  

  get isDirty() {
    this.modified.userNewPass
    return true
  }

  saveData() {    
    if ((this.$refs.changePasswordForm as HTMLFormElement).validate()) {
      this.saving = true
      this.$store.myActions.AUTH_CHANGE_PASSWORD_REQUEST(this.modified).then(() =>{
          this.$store.myActions.UI_ADD_SNACK_MESSAGE("Mot de passe modifié avec succès.")          
          this.showDrawer = false          
      }).catch((error) => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(error)          
      }).finally(() => {
        this.saving = false
      })
    }
  }

  
}
